import { useEffect } from 'react';

export function useBeforeColor(className: string, hexColor: string): void {
  useEffect(() => {
    const elements = document.querySelectorAll(`.${className}`);
    elements.forEach(element => {
      if (element instanceof HTMLElement) {
        element.style.setProperty('--bg-color', hexColor);
      }
    });
  }, [hexColor]); // 当 hexColor 变化时重新执行
}
